export default "__VITE_ASSET__5b4c5b30__"